var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[(_vm.chartdata)?_c('span',{staticClass:"alarmeJeBereich"},[(_vm.loaded)?_c('bar-chart',{attrs:{"chartdata":_vm.chartdata,"options":_vm.options},on:{"set-chart":_vm.setChart}}):_vm._e()],1):(!_vm.chartdata && !_vm.loaded)?_c('div',{staticClass:"text-center"},[_c('SpinnerImage')],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }